export default __webpack_public_path__ + "static/media/img_step_car02.59e52e3a.jpg";